export default __webpack_public_path__ + "static/media/seguro_auto.e6df7018.png";